import { Box, FormLabel, Switch } from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import { useContext } from 'react'

import { SwitchControl } from '../../components/SwitchControl'
import { SearchField } from '../shared/SearchField'

export const UserListFilter = ({
  hideInactiveFilter,
}: {
  hideInactiveFilter?: boolean
}) => {
  const { filter, updateFilter, setCurrentPage, ...rest } =
    useContext(userListContext)

  return (
    <Box sx={{ display: 'flex', gap: 4, w: 'full' }}>
      <SearchField
        onSearch={(search) => {
          updateFilter({ ...filter, name: search, pageIndex: 1 })
        }}
      />

      {!hideInactiveFilter && (
        <SwitchControl sx={{ flexGrow: 1, justifyContent: 'right' }} mr={2}>
          <Switch
            size="md"
            id="showInactive"
            isChecked={filter.showInvalid}
            onChange={() => {
              updateFilter({ ...filter, showInvalid: !filter.showInvalid, pageIndex: 1 })
            }}
          />
          <FormLabel htmlFor="showInactive" variant="switch">
            Zobrazit i neaktivní
          </FormLabel>
        </SwitchControl>
      )}
    </Box>
  )
}
